import makeApiRequest from '@/services/makeApiRequest';
import store from '@/store';

/* eslint-disable class-methods-use-this */
class ApplicationService {
  async getApplication ({ uuid }) {
    const workspaceUuid = store.getters.getActiveWorkspaceUuid || store.state.activeWorkspace;

    return makeApiRequest(`/api/applicationV2?workspaceUuid=${workspaceUuid}&uuid=${uuid}`, 'GET');
  }

  async notifyRecommendation ({ applicationUuid, offerUuid, senderUuid }) {
    const workspaceUuid = store.getters.getActiveWorkspaceUuid || store.state.activeWorkspace;

    return makeApiRequest(`/api/applicationV2?workspaceUuid=${workspaceUuid}`, 'POST', {
      applicationUuid,
      offerUuid,
      senderUuid
    });
  }
}

export default new ApplicationService();
